module.exports = __webpack_public_path__ + "img/Horizon Real Estate.afec2813.png";